


















































import { Component, Prop, Vue } from 'vue-property-decorator'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformLogicJump } from '@/api/model/typeform/typeform-logic-jump'
import { TypeformLogicJumpAction } from '@/api/model/typeform/typeform-logic-jump-action'
import { TypeformReferenceRegExp } from '@/api/model/typeform/typeform-form'

@Component
export default class LogicJumpAction extends Vue {
    @Prop({ required: true }) readonly form!: TypeformForm
    @Prop({ required: true }) readonly logicJump!: TypeformLogicJump
    @Prop({ required: true }) readonly action!: TypeformLogicJumpAction

    formatReference(type: string, ref): string {
        if (type === 'hidden') {
            return ref
        }

        if (type === 'field') {
            const field = this.form.fields.find(f => f.ref === ref)
            if (field) {
                return field.title.replaceAll(TypeformReferenceRegExp, '_')
            }
        }

        if (type === 'thankyou') {
            const thankyou_screen = this.form.thankyou_screens.find(t => t.ref === ref)
            if (thankyou_screen) {
                return thankyou_screen.title.replaceAll(TypeformReferenceRegExp, '_')
            }
        }

        if (ref === true) {
            return this.$t('yes').toString()
        }

        if (ref === false) {
            return this.$t('no').toString()
        }

        return ref
    }
}
